// "What's this?" (issue 1155): the help control. In this board mode a tap on a token opens its campaign wiki card
// instead of selecting it — no selection, no drag. One board mode at a time: starting it stops every other tool, and
// every other tool stops it; Escape leaves it. The card itself (`wikiCard`) is also opened from the token menu's "Wiki".
// Held outside React, like the pointing tool.
import { wallTool } from './wallTool';
import { areaTool } from './areaTool';
import { drawTool } from './drawTool';
import { focusTool } from './focusTool';
import { fogTool } from './fogTool';
import { zoneTool } from './zoneTool';
import { measureTool } from './measureTool';
import { targetTool } from './targetTool';

export interface WhatsThis { on: boolean }
/** The card on screen: the token it is for, and where the tap was (screen pixels). */
export interface WikiCardAt { id: string; x: number; y: number }

type Listener<T> = (t: T) => void;
function cell<T>(initial: T) {
  let value = initial;
  const listeners = new Set<Listener<T>>();
  return {
    get: () => value,
    set(next: T) { value = next; for (const l of listeners) l(value); },
    subscribe(l: Listener<T>): () => void { listeners.add(l); return () => { listeners.delete(l); }; },
  };
}

const mode = cell<WhatsThis>({ on: false });
const card = cell<WikiCardAt | null>(null);

export const whatsThisTool = {
  get: mode.get,
  subscribe: mode.subscribe,
  start(): void {
    focusTool.stop(); measureTool.stop(); areaTool.stop(); targetTool.stop(); fogTool.stop(); drawTool.stop(); wallTool.stop(); zoneTool.stop();
    mode.set({ on: true });
  },
  stop(): void { if (mode.get().on) mode.set({ on: false }); },
  toggle(): void { if (mode.get().on) whatsThisTool.stop(); else whatsThisTool.start(); },
  /** A tap on a token in the mode: its card opens where the tap was. The mode stays, for the next token. */
  pick(id: string, x: number, y: number): void { card.set({ id, x, y }); },
};

export const wikiCard = {
  get: card.get,
  subscribe: card.subscribe,
  open(at: WikiCardAt): void { card.set(at); },
  close(): void { if (card.get()) card.set(null); },
};
